const defaultVariants = {
  control: "control",
  available: "available",
} as const;

export const Experiments = {
  HOMES: {
    name: "rbc-enable-homes",
    variants: defaultVariants,
  },
  HEADER_FOOTER: {
    name: "rbc-enable-header-footer",
    variants: defaultVariants,
  },
  AI_ASSIST_COPY_CONVERSATION_ID: {
    name: "AIAssistCopyConversationId",
    variants: defaultVariants,
  },
  DISABLE_REWARDS_PAYMENT: {
    name: "rbc-disable-rewards-payment",
    variants: defaultVariants,
  },
  FLIGHTS_ENABLED: {
    name: "FlightsEnabled",
    variants: defaultVariants,
  },
  STAYS_ENABLED: {
    name: "StaysEnabled",
    variants: defaultVariants,
  },
  CARS_ENABLED: {
    name: "CarsEnabled",
    variants: defaultVariants,
  },
  ACTIVITIES_ENABLED: {
    name: "ActivitiesEnabled",
    variants: defaultVariants,
  },
  PACKAGES_ENABLED: {
    name: "PackagesEnabled",
    variants: defaultVariants,
  },
  TRIPS_ENABLED: {
    name: "TripsEnabled",
    variants: defaultVariants,
  },
  HOMEPAGE_BANNER: {
    name: "homepage-banner",
    variants: defaultVariants,
  },
  SEATS_ENABLED: {
    name: "rbc-enable-seats",
    variants: defaultVariants,
  },
  EXCHANGE_ENABLED: {
    name: "ExchangeEnabled",
    variants: defaultVariants,
  },
  HTS_ASSIST_ENABLED: {
    name: "HtsAssistEnabled",
    variants: defaultVariants,
  },
  HTS_ASSIST_CSAT_ENABLED: {
    name: "HtsAssistCsatEnabled",
    variants: defaultVariants,
  },
  RBC_ALLIANZ_INSURANCE_ENABLED: {
    name: "rbc-enable-allianz-insurance",
    variants: defaultVariants,
  },
  FILTER_UNAVAILABLE_LODGINGS: {
    name: "rbc-filter-unavailable-lodgings",
    variants: defaultVariants,
  },
  RBC_ENABLE_PRICE_PREDICTION: {
    name: "rbc-enable-price-prediction",
    variants: defaultVariants,
  },
  AIRCANADA_PORTER_SHOW_ALL_GRID_FARES: {
    name: "rbc-aircanada-porter-show-all-grid-fares",
    variants: defaultVariants,
  },
  GRID_PRICE_PREDICTION_ENABLED: {
    name: "rbc-grid-price-prediction-enabled",
    variants: defaultVariants,
  },
  MAINTENANCE_PAGE_ENABLED: {
    name: "rbc-maintenance-page-enable",
    variants: defaultVariants,
  },
  IMPORTANT_NOTICE_BANNER: {
    name: "important-notice-banner",
    variants: defaultVariants,
  },
  WALLET_OFFERS: {
    name: "rbc-wallet-offers",
    variants: defaultVariants,
  },
  OFFERS_ENABLED: {
    name: "OffersEnabled",
    variants: defaultVariants,
  },
  CREDITS_ENABLED: {
    name: "CreditsEnabled",
    variants: defaultVariants,
  },
  HOTEL_FUNDED_OFFERS: {
    name: "rbc-hotel-funded-offers",
    variants: defaultVariants,
  },
  GRID_DEFAULT_POINTS: {
    name: "rbc-grid-default-points",
    variants: defaultVariants,
  },
  FLIGHT_CANCEL_V2_ENABLED: {
    name: "rbc-flight-cancel-v2",
    variants: defaultVariants,
  },
  LODGING_CANCEL_V2: {
    name: "rbc-lodging-cancel-v2",
    variants: defaultVariants,
  },
  GROUND_CANCEL_V2_ENABLED: {
    name: "rbc-ground-cancel-v2",
    variants: defaultVariants,
  },
  STAYS_X_BONUS_POINTS_EARN: {
    name: "rbc-stays-x-bonus-points-earn",
    variants: defaultVariants,
  },
  HTS_MEDIA: {
    name: "rbc-hts-media",
    variants: defaultVariants,
  },
  AVION_EARN_SUMMARY_LODGING: {
    name: "rbc-avion-earn-summary-lodging",
    variants: defaultVariants,
  },
  AVION_EARN_SUMMARY: {
    name: "rbc-avion-earn-summary",
    variants: defaultVariants,
  },
  WALLET_ENABLED: {
    name: "WalletEnabled",
    variants: defaultVariants,
  },
  UPSELL_STAYS_FROM_FLIGHTS: {
    name: "rbc-cross-sell-stays-from-flights",
    variants: {
      control: "control",
      available: "available",
      inline: "inline",
      sticky_bar: "sticky_bar",
      interstitial: "interstitial",
    },
  },
} as const;
